var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-link",
    {
      staticClass: "featured-offers-link",
      class: [_vm.colorClass, { active: _vm.offers.modalOpen }],
      attrs: { secondary: true },
      on: { click: _vm.onLinkClick }
    },
    [_vm._v(_vm._s(_vm.content + " (" + _vm.offers.offerCount + ")"))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }